import React, { useEffect, useState } from "react";
import axios from "axios";

const DepartmentList = ({ companyId }) => {
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);

  useEffect(() => {
    fetchDepartments(page);
  }, [page]);

  const fetchDepartments = async (currentPage) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `/api/companies/${companyId}/departments?page=${currentPage}`
      );
      setDepartments((prev) => [...prev, ...response.data.departments]);
      setIsLastPage(response.data.isLastPage);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
    setIsLoading(false);
  };

  const loadMore = () => {
    if (!isLastPage) setPage((prev) => prev + 1);
  };

  return (
    <main className="bg-white h-100" style={{ paddingBottom: "100px" }}>
      <div className="container mt-4">
        <h2 className="text-center">部署一覧</h2>
        <div className="row">
          {departments.map((department) => (
            <div className="col-md-4 mb-4" key={department.id}>
              <div className="card">
                <img
                  src={department.main_image_url || "/images/default_department_image.png"}
                  className="card-img-top"
                  alt={`${department.name}の画像`}
                />
                <div className="card-body">
                  <h5 className="card-title">{department.name}</h5>
                  <p className="card-text">{department.about}</p>
                  <a
                    href={`/community/${companyId}/departments/${department.id}`}
                    className="btn btn-primary"
                  >
                    詳細を見る
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        {isLoading ? (
          <div className="text-center mt-4">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          !isLastPage && (
            <div className="text-center mt-4">
              <button className="btn btn-outline-primary" onClick={loadMore}>
                もっと見る
              </button>
            </div>
          )
        )}
      </div>
    </main>
  );
};

export default DepartmentList;
